import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountStatementsPage} from 'features/deposit/statements/DepositAccountStatementsPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/deposits/$accountId/statements',
)({
  component: DepositAccountStatementsPage,
  staticData: {crumbKey: 'navigation.statements'},
});
